import { EntityVm } from "api/core/entity.vm";
import { IsEnum, IsString } from "class-validator";

export enum TeamRole {
    INVENTORY = "INVENTORY",
    RECEPTION = "RECEPTION",
    PICKING = "PICKING",
    PRODUCTION = "PRODUCTION"
}

export class TeamVm extends EntityVm {
    @IsString()
    name: string;

    @IsEnum(TeamRole)
    role: TeamRole;

    @IsString()
    warehouseId: string;
}
